<template>
    <div class="el-lw-bread-crumb">
        <div class="lw-breadcrumb">
            <div v-for="(tab, index) in filterBreadcrumb" :key="index" style="display: flex">
                <div class="lw-breadcrumb-item"
                     :class="{'lw-breadcrumb-item-last':index==filterBreadcrumb.length-1}"
                     v-show="tab.status&&tab.status==2">
                    <div style="white-space:nowrap;" @click="toRemoteRouter(tab)">{{tab.name}}</div>
                </div>

                <div class="lw-breadcrumb-item"
                     :class="{'lw-breadcrumb-item-last':index==filterBreadcrumb.length-1}"
                     v-show="!(tab.status&&tab.status==2)">
                    <div style="white-space:nowrap;" @click="toRouter(tab)">{{tab.name}}</div>
                </div>
                <div class="lw-breadcrumb-item__separator" v-show="index!=filterBreadcrumb.length-1">/</div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
  name: 'ElLwBreadCrumb',
  data() {
    return {
      breadcrumb: []
    };
  },
  created() {
  },
  computed: {
    breadList() {
      return this.$route.meta.breadList || [];
    },
    filterBreadcrumb() {
      return this.breadcrumbDeal(JSON.parse(JSON.stringify(this.breadList)));
    }
  },
  methods: {
    toRouter(tab) {
      let path = tab.path;
      if (tab.isClickCallBack) {
        this.$emit('click', tab)
        return;
      }
      if (path) {
        this.$router.push({path: path});
      }
    },
    toRemoteRouter(tab) {

      if (tab.isClickCallBack) {
        this.$emit('click', tab)
        return;
      }
      let path = tab.path;
      let urlType = tab.urlType;
      let gardenId = window.localStorage.getItem('gardenId');
      let qToken = window.localStorage.getItem("LWToken");
      window.location.href = this.filePre$[urlType] + `${path}?gardenId=${gardenId}&token=${qToken}`;
    },
    breadcrumbDeal(breadcrumb = []) {
      breadcrumb.forEach((e, index) => {
        if (index === breadcrumb.length - 1) {
          e.path = '';
        }
      });
      this.breadcrumb = breadcrumb;
      return this.breadcrumb;
    }
  }
};
</script>